import toMoment from '@/services/functions/dates/toMoment'

export default function clearDateAt (date, unitOfTime, clone = false) {
  return toMoment(date, clone)?.startOf(unitOfTime) ?? null
}

// AUTO-GENERATED EXPORTS START
// AUTO-GENERATED EXPORTS SIGNATURE: days.js->clearDateAtDays|hours.js->clearDateAtHours|millisecond.js->clearDateAtMillisecond|minutes.js->clearDateAtMinutes|months.js->clearDateAtMonths|quarters.js->clearDateAtQuarters|seconds.js->clearDateAtSeconds|weeks.js->clearDateAtWeeks|years.js->clearDateAtYears
export { default as clearDateAtDays } from './days'
export { default as clearDateAtHours } from './hours'
export { default as clearDateAtMillisecond } from './millisecond'
export { default as clearDateAtMinutes } from './minutes'
export { default as clearDateAtMonths } from './months'
export { default as clearDateAtQuarters } from './quarters'
export { default as clearDateAtSeconds } from './seconds'
export { default as clearDateAtWeeks } from './weeks'
export { default as clearDateAtYears } from './years'
// AUTO-GENERATED EXPORTS END
